import React, { useRef, useState } from "react"
import { Divider, IconButton, makeStyles, Popover, useTheme } from "@material-ui/core"
import { HelpOutline, LiveHelpOutlined, MailOutline } from "@material-ui/icons"
import Config from "react-global-configuration"
import { useCookies } from "react-cookie"
import userflow from "userflow.js"
import { Icon } from "../Icon"
import { HeaderMenuItem } from "./HeaderMenuItem"

const useStyles = makeStyles((theme) => ({
  menu: {
    minWidth: 307,
  },
  menuItem: {
    "&:hover": {
      background: theme.palette.primary.shaded.background,
    },
  },
  menuItemShaded: {
    backgroundColor: theme.palette.shaded.main,
    "&:hover": {
      background: theme.palette.shaded.main,
    },
  },
  menuUser: {
    fontSize: 16,
    lineHeight: "16px",
    fontWeight: "600",
    color: theme.palette.text.tinted,
  },
  menuLight: {
    fontSize: 12,
    lineHeight: "16px",
    color: theme.palette.text.light,
  },
  menuListItemIcon: {
    minWidth: "auto",
    paddingRight: theme.spacing(2),
  },
}))

const HelpMenu = ({ className, size = 22 }) => {
  const theme = useTheme()
  const classes = useStyles()
  const [{ hide_banners: hideBanners }, , removeCookie] = useCookies()
  const [helpEl, setHelpEl] = useState(null)
  const helpButtonEl = useRef(null)
  const {
    links: { help: helpLink, emailSupport },
    support: {
      userflow: { enabled: userflowEnabled },
    },
  } = Config.get()

  const handleClick = (event) => {
    setHelpEl(event.currentTarget)
  }
  const handleContactSupport = () => {
    window.location.href = `mailto:${emailSupport}`
    handleClose()
  }
  // const handleBeacon = (route) => {
  //   if (window.Beacon) {
  //     window.Beacon("open")
  //     window.Beacon("navigate", route)
  //   }
  //   handleClose()
  // }
  const handleHelpCenter = () => {
    // currently disabled
    window.open(helpLink, "_blank")
  }
  const handleBanners = () => {
    removeCookie("hide_banners")
    handleClose()
  }
  const handleChecklist = () => {
    if (!userflowEnabled) {
      console.log("[HelpMenu]", "Userflow not available, check config")
      return
    }
    userflow.start("22d655af-6ff2-494c-b0cc-825a6a8e2ac1")
    handleClose()
  }
  const handleWelcome = () => {
    if (!userflowEnabled) {
      console.log("[HelpMenu]", "Userflow not available, check config")
      return
    }
    userflow.start("e76a65f1-5eba-4c70-9c86-6b44dd4e5565")
    handleClose()
  }
  const handleClose = () => {
    setHelpEl(null)
  }

  return (
    <>
      <IconButton ref={helpButtonEl} title="Help" aria-label="Help" onClick={handleClick} className={className}>
        <Icon name="help" style={{ width: size, height: size }} />
      </IconButton>
      <Popover
        open={Boolean(helpEl)}
        anchorEl={helpEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: theme.spacing(1), horizontal: "right" }}
        classes={{ paper: classes.menu }}
      >
        <HeaderMenuItem onClick={handleContactSupport} text="Contact support" icon={<MailOutline />} />
        <Divider />
        <HeaderMenuItem onClick={handleHelpCenter} text="Help Center" icon={<HelpOutline />} />
        <Divider />
        <HeaderMenuItem
          onClick={handleBanners}
          text="Show help banners"
          icon={<LiveHelpOutlined />}
          disabled={!hideBanners}
        />
        <HeaderMenuItem onClick={handleChecklist} text="Show Get Started checklist again" icon={<LiveHelpOutlined />} />
        <HeaderMenuItem onClick={handleWelcome} text="Show Welcome video again" icon={<LiveHelpOutlined />} />
      </Popover>
    </>
  )
}

export { HelpMenu }
